import React, { useEffect, useState } from "react";

function AssignTrackingId({ isOpen, onClose, data, setData, onSubmit }) {

    const token = sessionStorage.getItem('tokenKey');
    const BASE_URL = process.env.REACT_APP_PP_URL;

    const handleInputChange = (orderId, trackingId) => {
        setData((prev) =>
            prev.map((item) =>
                item.orderId === orderId ? {
                    ...item, updateOrderDetails: {
                        ...item.updateOrderDetails,
                        orderTrackingId: trackingId,
                    }
                } : item
            )
        );
    };

    const handleSelect = (orderId, trackingId) => {

        setData((prev) =>
            prev.map((item) =>
                item.orderId === orderId ? {
                    ...item, updateOrderDetails: {
                        ...item.updateOrderDetails,
                        courierPartnerId: trackingId,
                    }
                } : item
            )
        );
    };

    const [list, setList] = useState([]);
    const courier = async () => {
        try {
            const res = await fetch(`${BASE_URL}/admin/v1/courier/list-in-key-value`, {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${token}`,
                }
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                setList(getRes.responsePacket);
                setData((prev) =>
                    prev.map((item) => ({
                        ...item,
                        updateOrderDetails: {
                            ...item.updateOrderDetails,
                            courierPartnerId: getRes.responsePacket?.[0].value,
                        }
                    }))
                );
            }
        } catch (e) {
            console.log(e, "error in courier")
        }
    }
    useEffect(() => {
        if (isOpen) {
            courier();
        }
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <>
            <div className="modal-overlay">
                <div style={{ width: "60%", backgroundColor: "white", padding: "10px", maxHeight: "100vh", overflow: "scroll" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <thead>
                            <tr>
                                <th style={{ border: "1px solid #ddd", padding: "8px" }}>Order ID</th>
                                <th style={{ border: "1px solid #ddd", padding: "8px" }}>Tracking ID</th>
                                <th style={{ border: "1px solid #ddd", padding: "8px" }}>Courier Partner ID</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.map((row, index) => (
                                <tr key={index}>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>{row.orderId}</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
                                        <input
                                            type="text"
                                            placeholder="Enter Tracking ID"
                                            value={row?.updateOrderDetails.orderTrackingId}
                                            onChange={(e) => handleInputChange(row.orderId, e.target.value)}
                                            style={{
                                                width: "100%",
                                                padding: "6px",
                                                border: "1px solid #ccc",
                                                borderRadius: "4px",
                                            }}
                                        />
                                    </td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
                                        <select value={row?.updateOrderDetails?.courierPartnerId} id={row?.updateOrderDetails?.courierPartnerId} onChange={(e) => handleSelect(row.orderId, e.target.value)}
                                            style={{ padding: "5px", margin: 0, fontSize: "16px" }}
                                        >
                                            <option value=""></option>
                                            {
                                                list?.map((itm) => {
                                                    return (
                                                        <option key={itm.value} value={itm.value}>{itm.label}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "10px", marginBottom: "10px" }}>
                        <button style={{ padding: "10px", marginRight: "10px", backgroundColor: "green", color: "white", cursor: "pointer" }} onClick={onSubmit} >Submit</button>
                        <button style={{ padding: "10px", marginRight: "10px", backgroundColor: "red", color: "white", cursor: "pointer" }} onClick={onClose}>cancel</button>
                    </div>
                </div>
            </div>
        </>
    )
}
export { AssignTrackingId }